export default "__VITE_ASSET__ddc2d406__"